import { render, staticRenderFns } from "./DisplayRmaModal.vue?vue&type=template&id=3272f697&"
import script from "./DisplayRmaModal.vue?vue&type=script&lang=js&"
export * from "./DisplayRmaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports